import React from 'react';

import { Sales } from 'containers/Forms/RecentSalesList';

import PurchasesList from './PurchasesList';

type Props = {
  done: boolean;
  loading: string;
  name: boolean;
  onMore: () => void;
  sales: Sales;
  showFilter: boolean;
  title: string;
  getRowExpandedState(key: string): boolean;
  setRowExpandedState(key: string, value: boolean): void;
};

const PreviousPurchases: React.FC<Props> = ({
  title,
  sales,
  loading,
  done,
  onMore,
  name,
  getRowExpandedState,
  setRowExpandedState,
}) => {
  return (
    <PurchasesList
      title={title}
      showName={name}
      sales={sales}
      loadMore={!done ? onMore : undefined}
      loadingText={loading}
      getRowExpandedState={getRowExpandedState}
      setRowExpandedState={setRowExpandedState}
    />
  );
};

export default PreviousPurchases;
